import { faker } from '@faker-js/faker'
import { Factory } from 'miragejs'

export default Factory.extend({
  firstName(i) {
    faker.seed(i)
    return faker.person.firstName()
  },
  lastName(i) {
    faker.seed(i)
    return faker.person.lastName()
  },
  login() {
    return faker.internet.username({ firstName: this.firstName, lastName: this.lastName })
  },
  email(i) {
    faker.seed(i)
    return faker.internet.email({ firstName: this.firstName, lastName: this.lastName })
  },
  sisId() {
    return null
  },
})
